import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DrawControlButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "$pressed",
})<{ $pressed?: boolean }>(({ $pressed }) => ({
  width: "2.75rem",
  height: "2.75rem",
  minWidth: "auto",
  backgroundColor: "white",
  color: "#555",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  "&.Mui-disabled": {
    pointerEvents: "auto",
    color: "#ccc",
  },
  "&.MuiButtonGroup-groupedContainedVertical:not(:last-child)": {
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottom: "1px solid #e0e0e0",
  },
  "&.MuiButtonGroup-groupedContainedVertical:not(:first-child)": {
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,
  },
  ...($pressed && {
    backgroundColor: "#e8f5e9 !important",
    color: "#388e3c !important",
    "@media (hover: hover)": {
      "&:hover": {
        backgroundColor: "#c8e6c9 !important",
      },
    },
  }),
}));
